import React from 'react';
import { Button } from '@mui/material';
import { PlusIcon } from 'assets';

interface AddNewAllocationSetupButtonProps {
    onClick: () => void;
}

export const AddNewAllocationSetupButton = ({ onClick }: AddNewAllocationSetupButtonProps) => (
    <Button
        sx={{ width: 'fit-content', padding: '6px 17px', height: '36px', borderRadius: 2, marginTop: '8px' }}
        variant="contained"
        onClick={onClick}
        startIcon={<PlusIcon />}
        aria-label="Add new allocation setup"
    >
        Add New Allocation Setup
    </Button>
);